/*
  TatyStore · funciones de respaldo del tema
  ------------------------------------------------------------------
  El tema llama a funciones globales (debounce, trapFocus, removeTrapFocus,
  pauseAllMedia) y al elemento <quantity-input>, pero su archivo JS principal
  llega vacío (shrine.null.js = 0 bytes). Sin ellas:
    - las miniaturas de la galería no cambian la imagen principal,
    - los botones − / + de cantidad no hacen nada,
    - las ventanas modales generan errores de consola.

  Este archivo SOLO define lo que no exista. Si en el futuro se instala la
  versión completa del tema, sus funciones originales tienen prioridad.
  No toca Releasit, el carrito ni el checkout.
*/
(function () {
  'use strict';

  if (typeof window.debounce !== 'function') {
    window.debounce = function (fn, wait) {
      var t;
      return function () {
        var ctx = this, args = arguments;
        clearTimeout(t);
        t = setTimeout(function () { fn.apply(ctx, args); }, wait);
      };
    };
  }

  if (typeof window.pauseAllMedia !== 'function') {
    window.pauseAllMedia = function () {
      document.querySelectorAll('.js-youtube').forEach(function (v) {
        try { v.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*'); } catch (e) {}
      });
      document.querySelectorAll('.js-vimeo').forEach(function (v) {
        try { v.contentWindow.postMessage('{"method":"pause"}', '*'); } catch (e) {}
      });
      document.querySelectorAll('video').forEach(function (v) {
        if (!v.closest('internal-video') && !v.autoplay) { try { v.pause(); } catch (e) {} }
      });
      document.querySelectorAll('product-model').forEach(function (m) {
        if (m.modelViewerUI) { try { m.modelViewerUI.pause(); } catch (e) {} }
      });
    };
  }

  var focusSelector = "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe";
  var trapHandlers = {};

  if (typeof window.trapFocus !== 'function') {
    window.trapFocus = function (container, elementToFocus) {
      if (!container) return;
      var elements = Array.prototype.slice.call(container.querySelectorAll(focusSelector));
      var first = elements[0];
      var last = elements[elements.length - 1];
      window.removeTrapFocus();
      trapHandlers.keydown = function (event) {
        if (event.code && event.code.toUpperCase() !== 'TAB') return;
        if (event.key && event.key !== 'Tab') return;
        if (event.target === last && !event.shiftKey) { event.preventDefault(); if (first) first.focus(); }
        if ((event.target === container || event.target === first) && event.shiftKey) { event.preventDefault(); if (last) last.focus(); }
      };
      document.addEventListener('keydown', trapHandlers.keydown);
      var target = elementToFocus || container;
      try { target.focus(); } catch (e) {}
    };
  }

  if (typeof window.removeTrapFocus !== 'function') {
    window.removeTrapFocus = function (elementToFocus) {
      if (trapHandlers.keydown) document.removeEventListener('keydown', trapHandlers.keydown);
      trapHandlers.keydown = null;
      if (elementToFocus) { try { elementToFocus.focus(); } catch (e) {} }
    };
  }

  // Selector de cantidad (− / +). Respeta min, max y step del producto.
  // Se registra al terminar la carga del documento para no chocar con una
  // posible versión original del tema que lo defina antes.
  function defineQuantityInput() {
  if (window.customElements && !customElements.get('quantity-input')) {
    customElements.define('quantity-input', class extends HTMLElement {
      connectedCallback() {
        if (this._tatyReady) return;
        this._tatyReady = true;
        this.input = this.querySelector('input');
        if (!this.input) return;
        this.querySelectorAll('button[name="plus"], button[name="minus"]').forEach((btn) => {
          btn.addEventListener('click', (event) => {
            event.preventDefault();
            this.step(btn.name === 'plus' ? 1 : -1);
          });
        });
        this.input.addEventListener('change', () => this.clamp());
      }
      limits() {
        var min = parseInt(this.input.dataset.min || this.input.min, 10);
        var max = parseInt(this.input.dataset.max || this.input.max, 10);
        var step = parseInt(this.input.step, 10);
        return {
          min: isNaN(min) || min < 1 ? 1 : min,
          max: isNaN(max) ? null : max,
          step: isNaN(step) || step < 1 ? 1 : step
        };
      }
      step(direction) {
        var l = this.limits();
        var current = parseInt(this.input.value, 10);
        if (isNaN(current)) current = l.min;
        var next = current + direction * l.step;
        if (next < l.min) next = l.min;
        if (l.max !== null && next > l.max) next = l.max;
        if (next === current) return;
        this.input.value = next;
        this.input.dispatchEvent(new Event('input', { bubbles: true }));
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      clamp() {
        var l = this.limits();
        var v = parseInt(this.input.value, 10);
        if (isNaN(v) || v < l.min) this.input.value = l.min;
        else if (l.max !== null && v > l.max) this.input.value = l.max;
      }
    });
  }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', defineQuantityInput);
  else defineQuantityInput();
})();
